// extracted by mini-css-extract-plugin
export default {"loaderContainer":"style_loaderContainer__xVipt"};